export class CameraService {

  async getStream () {

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: false
      })

      return stream
    } catch (error) {
      return 'error'
    }
  }

  closeStream (stream: any) : void {
    stream.getTracks().forEach((track: any) => {
      track.stop()
    })
  }



}
